import { cn } from '@/lib/utils'
import { type VariantProps, cva } from 'class-variance-authority'
import { forwardRef } from 'react'

const homeTitleVariants = cva('font-semibold leading-tight text-neutral-800', {
  variants: {
    size: {
      hero: 'text-4xl',
      section: 'text-3xl lg:text-4xl',
      card: 'text-2xl lg:text-3xl',
      feature: 'text-xl',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
    },
  },
  defaultVariants: {
    size: 'section',
    align: 'left',
  },
})

export interface HomeTitleProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof homeTitleVariants> {
  as?: 'h1' | 'h2' | 'h3' | 'h4'
}

const HomeTitle = forwardRef<HTMLHeadingElement, HomeTitleProps>(
  ({ className, size, align, as: Comp = 'h2', children, ...props }, ref) => {
    return (
      <Comp className={cn(homeTitleVariants({ size, align, className }))} ref={ref} {...props}>
        {children}
      </Comp>
    )
  },
)

HomeTitle.displayName = 'HomeTitle'

export { HomeTitle, homeTitleVariants }
